import * as React from 'react';
import { buildClassName } from 'utils/build-class-name';
import styles from './switch.module.scss';

interface SwitchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'checked' | 'onChange'> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, checked, onCheckedChange, ...props }, ref) => {
    return (
      <label className={buildClassName(styles.switch, checked && styles.checked, className)}>
        <input
          type="checkbox"
          ref={ref}
          checked={checked}
          onChange={e => onCheckedChange?.(e.target.checked)}
          style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', borderWidth: 0 }}
          {...props}
        />
        <span className={styles.thumb} />
      </label>
    );
  }
);
Switch.displayName = 'Switch';

export { Switch };
